import { Injectable, inject } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Subscription, distinctUntilChanged, filter } from "rxjs";
import { InactivityService } from "./inactivity.service";

export function isActivityTractingEnabled(route: ActivatedRoute, lastConfiguration?: boolean): boolean | undefined {

    //if the configuration is available for the current route, it will be considered as lastConfiguration
    if (route.snapshot.data['enableActivityTracking'] != undefined) {
        lastConfiguration = route.snapshot.data['enableActivityTracking'];
    }

    if (route.children.length == 0) {
        //if there are no more children, last available configuration will be returned
        return lastConfiguration;
    } else {
        for (let child of route.children) {
            //drilling down to get the last available configuration from the deepest child hierarchy
            return isActivityTractingEnabled(child, lastConfiguration);
            
            
        }
    }

    //if there is no configuration, undefined will be returned
    return undefined;
}

@Injectable({
    providedIn: 'root'
})
export class CWSInactivityService {
    private inactivityService = inject(InactivityService);
    private activatedRoute = inject(ActivatedRoute);
    private router = inject(Router);


    private subscription$: Subscription = Subscription.EMPTY;

    /**
     * Returns true if this service is listening to the router in order to manage the titles
     */
    public get isMonitoring() {
        return this._isMonitoring;
    }

    private _isMonitoring = false;;

    /**
    * Starts listening to the router in order to manage the title
    */
    startMonitoring() {
        if (this._isMonitoring) {
            return;
        }
        this._isMonitoring = true;

        /* istanbul ignore next */
        this.subscription$ = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            distinctUntilChanged()).subscribe(() => {
                const isEnabled = isActivityTractingEnabled(this.activatedRoute);
                
                if(isEnabled){
                    this.inactivityService.startTrackingInactivity();
                }else{
                    this.inactivityService.stopTrackingInactivity();
                }

            });
    };

    /**
     * Stops listening to the router
     */
    stopMonitoring() {
        this.subscription$.unsubscribe();
        this.subscription$ = Subscription.EMPTY;
        this._isMonitoring = false;
    };

    public ngOnDestroy() {
        this.stopMonitoring();
    };
}